export default __webpack_public_path__ + "device_doorbell_3.70b79391.png";